import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs><clipPath id="b"><rect width="30" height="30"/></clipPath></defs><g id="a" clipPath="url(#b)"><path d="M-12.826-28.294a2.32,2.32,0,0,0,2.3,2.192h9.318a2.32,2.32,0,0,0,2.3-2.192l.8-16.078H3.27v-.95H-2.1v-.987A1.583,1.583,0,0,0-3.673-47.88H-8.057a1.583,1.583,0,0,0-1.571,1.571v.987H-15v.95h1.37Zm4.147-18.014a.616.616,0,0,1,.621-.621h4.385a.616.616,0,0,1,.621.621v.987H-8.679ZM.146-28.331a1.36,1.36,0,0,1-1.352,1.279h-9.318a1.36,1.36,0,0,1-1.352-1.279l-.8-16.041H.95Zm-8.459-1-.438-12.771-.95.018L-9.263-29.3ZM-5.39-42.107h-.95v12.789h.95Zm3.362.018-.95-.018-.438,12.771.95.037Z" transform="translate(21 51.881)" fill="#1f1f1f"/></g></svg>
    );
}


